import { listReviews } from "@/lib/reviews.functions";

// Kept in its own module so route loaders can prefetch reviews without pulling
// the whole ProductReviews UI (and sonner/form components) into the main bundle.
export function reviewsQueryOptions(productId: string) {
  return {
    queryKey: ["product-reviews", productId] as const,
    queryFn: () => listReviews({ data: { productId } }),
    staleTime: 60_000,
  };
}
